module.exports = __webpack_public_path__ + "img/noOrder.90017ce2.png";